import { url } from '../../config/url';
/**
 * Путь страницы → ключ перевода для её названия.
 *
 * Подписи те же, что в боковом меню: вкладка и пункт меню, ведущие в одно
 * место, обязаны называться одинаково, иначе вкладки читаются как другой
 * раздел. Правите меню — правьте и здесь.
 *
 * Список отсортирован от длинных путей к коротким для читаемости; на отбор
 * это не влияет, совпадение проверяется целиком или до следующей косой
 * черты, поэтому «/journal» не перехватывает «/schedule/journal».
 */
const PAGE_TITLES = [
    // преподаватель
    ['/schedule/disciplines', 'my_disciplines'],
    ['/schedule/dashboard', 'dashboard'],
    ['/schedule/retakes', 'rt_menu'],
    ['/schedule/substitute', 'sb_menu'],
    ['/schedule/ctp-plan', 'ctp_plan'],
    ['/schedule/requests', 'req_mine'],
    ['/schedule/journal', 'journal'],
    ['/schedule/search', 'search_student'],
    ['/schedule/tasks', 'tasks'],
    /* «/schedule/day» сюда не вписан намеренно: день занятий — не отдельный
       раздел, а страница внутри «Сегодня», как карточка задания внутри
       «Заданий». Со своей строкой он заводил вторую вкладку с тем же
       названием, и в шапке висели две «Сегодня» подряд. */
    ['/schedule', 'today'],
    // деканат
    ['/dekanat/teacher-journal', 'tj_menu'],
    ['/dekanat/dashboard', 'dashboard'],
    ['/dekanat/analytics', 'an_menu'],
    ['/dekanat/permission', 'permissions'],
    ['/dekanat/requests', 'req_menu'],
    ['/dekanat/retakes', 'rt_menu'],
    ['/dekanat/transfer', 'tr_menu'],
    ['/dekanat', 'search_student'],
    // отчёты
    ['/retake', 'workeds_out'],
    ['/journal', 'rep_journal'],
    // студент
    ['/student/dashboard', 'dashboard'],
    ['/student/retakes', 'rt_menu'],
    ['/student/tasks', 'tasks'],
    ['/student/schedule', 'today'],
    ['/transaction', 'transaction'],
    ['/payment', 'payment'],
    ['/passes', 'passes'],
    ['/worked', 'workeds_out'],
    ['/student', 'journal']
];
/**
 * Раздел, которому принадлежит адрес, и ключ его названия.
 *
 * Возвращает null для служебных адресов — входа и проверки токена:
 * вкладка для них не заводится, закрывать её некуда, а после выхода
 * она бы висела в списке.
 *
 * Адрес приводится к корню раздела: карточка задания «/schedule/tasks/5»
 * попадает во вкладку «Задания», а не заводит вторую с тем же названием.
 * Отбирать по одному только ключу нельзя — «Журнал» есть и у
 * преподавателя, и у деканата, и в отчётах, и это разные страницы.
 */
export const matchRoute = (pathname) => {
    const p = pathname.startsWith(url) ? pathname.slice(url.length) : pathname;
    const hit = PAGE_TITLES.find(([route]) => p === route || p.startsWith(route + '/'));
    return hit ? { route: url + hit[0], key: hit[1] } : null;
};
